import { EmeraldError } from 'src/common/api/emerald-error';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { VerticalAlignment } from 'src/common/enumerations/verticalAlignment';
import { WicTenderRestriction } from 'src/common/helpers/error-code';
import { IMessageModal, MessageModalSizeEnum } from 'src/common/interfaces/dtos/IMessageModal';
import { ICustomerState } from 'src/common/interfaces/states/ICustomerState';
import { applyCartResponse } from 'src/home-page/business-logic/common/apply-cart-response';
import { showEwicErrorModal } from 'src/tendering/business-logic/handle-ewic-error-handling';
import {
  IRemoveCustomerFromTransactionParams,
  removeCustomerFromTransaction,
} from '../../common/helpers/transaction-helper';
import { store } from '../../common/redux/configure-store';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { voidEmptyTransaction } from './void-transaction';

const REMOVE_CUSTOMER_MODAL = 'REMOVE_CUSTOMER_MODAL';
export const removeCustomerHandler = async (): Promise<void> => {
  const transactionCustomer = store.getState().transaction.transactionCustomer;
  const customerName = `${transactionCustomer?.firstName || ''} ${transactionCustomer?.lastName ||
    ''}`;
  const messageProps: IMessageModal = {
    type: EmeraldDialogTypes.InfoDecision,
    message: 'Remove_Customer_Command',
    subMessage: 'Remove_Customer_Confirmation',
    subMessageArgs: { arg: customerName.replace(' ', String.fromCharCode(160)) },
    onAccept: () => removeLoyaltyCustomer(transactionCustomer),
    onCancel: () => popEmeraldModal(REMOVE_CUSTOMER_MODAL),
    disableBackdropClick: true,
    acceptButtonLabel: 'Yes_CommandName',
    closeButtonLabel: 'No_CommandName',
    size: MessageModalSizeEnum.Medium,
    verticalAlignment: VerticalAlignment.Center,
    modalId: REMOVE_CUSTOMER_MODAL,
  };
  showEmeraldDialog(messageProps);
};

const removeLoyaltyCustomer = async (customer?: Partial<ICustomerState>): Promise<void> => {
  if (customer) {
    const transactionId = store.getState().transaction.transactionId;
    const params: IRemoveCustomerFromTransactionParams = {
      transactionId,
      consumerAccountNumber: customer.consumerAccountNumber ?? '',
    };
    popEmeraldModal(REMOVE_CUSTOMER_MODAL);
    return withSpinner(() =>
      removeCustomerFromTransaction(params)
        .then(applyCartResponse)
        .then(() => {
          store.dispatch(TransactionActions.removeCustomer());
          voidEmptyTransaction();
        })
        .catch((err: EmeraldError) => {
          if (err.code === 'EmeraldItemNotFound') {
            err.code = 'TransactionNotFound';
          } else if (err.code === WicTenderRestriction) {
            err.message = 'EwicAddRemoveLoyalty';
            return showEwicErrorModal(err);
          }
          popupMessage(err);
        }),
    );
  }
};
